<template>
  <div class="body-width  div-top">
    <ul class="breadcrumb">
      <li class="li-padding-left20" @mouseenter="handleEnter('/productzncy/zncajkzzx')" @mouseleave="handleLeave('/productzncy/zncajkzzx')">
        <a @click="setroters('/productzncy/zncajkzzx')">
          <span :class="zncajkzzx===true?'font-Normal-1400':'font-Normal-14B6'">智能船岸基控制中心</span>
        </a>
      </li>
      <li @mouseenter="handleEnter('/productzncy/znzzjsjxt')" @mouseleave="handleLeave('/productzncy/znzzjsjxt')">
        <a @click="setroters('/productzncy/znzzjsjxt')">
          <span :class="znzzjsjxt===true?'font-Normal-1400':'font-Normal-14B6'">智能装载机系统-SmartLoad</span>
        </a>
      </li>
      <li @mouseenter="handleEnter('/productzncy/zncq')" @mouseleave="handleLeave('/productzncy/zncq')">
        <a @click="setroters('/productzncy/zncq')">
          <span :class="zncq===true?'font-Normal-1400':'font-Normal-14B6'">智能船桥</span>
        </a>
      </li>
    </ul>
  </div>

</template>
<script>
  export default {
    name: "zncyheader",
    data() {
      return {
        zncajkzzx: false,
        znzzjsjxt: false,
        zncq: false,

        iszncajkzzx:false,
        isznzzjsjxt:false,
        iszncq:false,
      }
    },
    methods: {
      handleEnter(src) {
        if (src === '/productzncy/zncajkzzx') {
          this.zncajkzzx = true
        }
        if (src === '/productzncy/znzzjsjxt') {
          this.znzzjsjxt = true
        }
        if (src === '/productzncy/zncq') {
          this.zncq = true
        }
      },
      handleLeave(src) {
        if (src === '/productzncy/zncajkzzx') {
          if(!this.iszncajkzzx){
            this.zncajkzzx = false
          }
        }
        if (src === '/productzncy/znzzjsjxt') {
          if(!this.isznzzjsjxt){
            this.znzzjsjxt = false
          }
        }
        if (src === '/productzncy/zncq') {
          if(!this.iszncq){
            this.zncq = false
          }
        }
      },

      setroters(src) {
        if (src === '/productzncy/zncajkzzx') {
          this.zncajkzzx = true
          this.iszncajkzzx = true
        } else {
          this.zncajkzzx = false
          this.iszncajkzzx = false
        }
        if (src === '/productzncy/znzzjsjxt') {
          this.znzzjsjxt = true
          this.isznzzjsjxt = true
        } else {
          this.znzzjsjxt = false
          this.isznzzjsjxt = false
        }
        if (src === '/productzncy/zncq') {
          this.zncq = true
          this.iszncq = true
        } else {
          this.zncq = false
          this.iszncq = false
        }
        this.$router.push(src);
      }
    },
    mounted() {
      this.setroters('/productzncy/zncajkzzx');
    }
  }

</script>

<style scoped>
  .div-top {
    margin-top: 50px;
  }
.breadcrumb{
   background-color: #fbfbfb !important;
}
  .breadcrumb > li + li:before {
 
    color: #666666;
    content: "| ";
    padding: 0 16px;
  }
  .li-padding-left20 {
    padding-left: 380px;
  }


</style>



// WEBPACK FOOTER //
// src/components/contentcoms/prodecutcontentcoms/zncyxlcp/zncyheader.vue